// extracted by mini-css-extract-plugin
export default {"videoForm":"assignmentForm_videoForm__LeYDR"};